// extracted by mini-css-extract-plugin
export var form = "_4l-0";